"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _clsx = _interopRequireDefault(require("clsx"));

var _styles = require("@material-ui/core/styles");

var _Box = _interopRequireDefault(require("./Box"));

var _excluded = ["children", "className", "componentRef"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var styles = (0, _styles.makeStyles)(function (theme) {
  return {
    root: {
      // '& > div': {
      //   marginTop: '2.625rem',
      // },
      background: theme.palette.background.default,
      borderRadius: '1.5rem 0rem 0rem 1.5rem;',
      display: 'flex;',
      height: '100%;'
      /* needed for container min-height */
      ,
      flexDirection: 'column;',
      flexGrow: 1,
      marginLeft: '-1.2rem',
      maxHeight: '100vh',
      minHeight: '100vh',
      overflow: 'auto',
      zIndex: '1201'
    }
  };
});

var Content = function Content(props) {
  var children = props.children,
      className = props.className,
      componentRef = props.componentRef,
      other = _objectWithoutProperties(props, _excluded);

  var classes = styles();
  return /*#__PURE__*/_react.default.createElement("main", _extends({
    className: (0, _clsx.default)(classes.root, className)
  }, other), /*#__PURE__*/_react.default.createElement(_Box.default, {
    ref: componentRef,
    style: {
      padding: '2.50rem'
    }
  }, children));
};

Content.propTypes = {
  children: _propTypes.default.node.isRequired,
  className: _propTypes.default.string
};
Content.defaultProps = {
  className: '',
  children: /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null)
};
var _default = Content;
exports.default = _default;